export default __webpack_public_path__ + "static/Crowne-BrandPortfolio-8470a1b63418cc85bbf5aa028fa801d5.png";